import { render, staticRenderFns } from "./TakipAcIslemDetayView.vue?vue&type=template&id=24ef8550&scoped=true"
import script from "./TakipAcIslemDetayView.vue?vue&type=script&lang=ts"
export * from "./TakipAcIslemDetayView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ef8550",
  null
  
)

export default component.exports